import React from "react";
import {Admission} from "@reside/reside-api-admission";
import {Button, DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../../helper";
import {
  ModalName,
  useDashboardModalContext,
} from "../../../DashboardModalContext";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";

const useApproveAdmissionAction = (admission: AdmissionFromSearch) => {
  const {toggleModal} = useDashboardModalContext(ModalName.APPROVE);
  const onApprove = () => {
    toggleModal(admission);
  };
  const testId = getResidentTestId(admission, Admission.StatusEnum.APPROVED);
  return {onApprove, testId};
};

export const ApproveAdmissionDropdownItem = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {onApprove, testId} = useApproveAdmissionAction(admission);

  return (
    <DropdownMenuItem onClick={onApprove} testId={testId}>
      Approve
    </DropdownMenuItem>
  );
};

export const ApproveAdmissionFooterButton = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {onApprove, testId} = useApproveAdmissionAction(admission);

  return (
    <Button
      size="small"
      color="primary"
      outline
      flat
      onClick={onApprove}
      testId={testId}
    >
      Approve
    </Button>
  );
};
